import { LINKEDIN_URL_PREFIX, TWITTER_SHARE_URL_PREFIX } from "../../constants/index";
import { IPublishData, IPublishSenderEmails } from "./interfaces";

export const serializePublishData = (jsonData: any): IPublishData => {
  let data: IPublishData = {} as IPublishData;

  data.xiq_internal_user = jsonData.xiq_internal_user;
  data.subject = jsonData.version_subject;
  data.asset_name = jsonData.asset_name;
  data.total_recipients = jsonData.total_recipients;
  data.outlook_sender_email_address = jsonData.outlook_sender_email_address;
  data.outlook_sender_name = jsonData.outlook_sender_name;
  data.sender_name = jsonData.sender_name;
  data.include_audience = jsonData.include_audience;
  data.reply_to_status = jsonData.reply_to_status;
  data.reply_to_email = jsonData.reply_to_email;
  data.email_platform = jsonData.email_platform;
  data.scheduled_datetime = jsonData.scheduled_datetime;
  data.mail_to = [...jsonData.mail_to];
  data.selected_sender = jsonData.selected_sender;
  data.selected_contacts = jsonData.selected_contacts;
  data.selected_lists = jsonData.selected_lists;
  data.status = jsonData.status;
  data.scheduled_timezone = jsonData.scheduled_timezone;
  data.is_scheduled = jsonData.is_scheduled;
  data.outlook_route = jsonData.outlook_route;
  data.email_type = jsonData.asset_type; // set the type of email (custom||adhoc||1 OR hybrid||digest||0)

  let senderEmails: IPublishSenderEmails[] = [];

  for (let email of jsonData.sender_emails) {
    senderEmails.push({
      domain: email["domain"],
      active: email["active"],
      verified: email["verified"],
      id: email["id"],
      sender_emails_sending_platform: email["sender_emails_sending_platform"],
    });
  }
  data.sender_emails = senderEmails;

  return data;
};

export const shareEmailOnLinkedIn = (url: string) => {
  var share_window_url = LINKEDIN_URL_PREFIX;
  if (url !== undefined && url !== "") share_window_url += encodeURIComponent(url);
  var pop = window.open(share_window_url, "Image", "width=1024, height=640,scrollbars=yes");
  pop?.focus();
};

export const shareEmailOnTwitter = (url: string) => {
  var share_window_url = TWITTER_SHARE_URL_PREFIX;
  if (url !== undefined && url !== "") share_window_url += "&url=" + encodeURIComponent(url);
  share_window_url += "&via=xiqinc";
  var pop = window.open(share_window_url, "Image", "width=1024, height=640,scrollbars=yes");
  pop?.focus();
};
